export const LlmIntegrationBestPractices = () => (
  <section className="py-8 sm:py-12">
    <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">Production Best Practices</h2>
    <div className="grid md:grid-cols-2 gap-4">
      {[
        { title: "Use Streaming", desc: "Show responses as they generate for better UX" },
        { title: "Implement Caching", desc: "Cache identical prompts to reduce costs" },
        { title: "Add Fallbacks", desc: "Switch providers when one fails" },
        { title: "Set Rate Limits", desc: "Protect against abuse and cost spikes" },
        { title: "Log Everything", desc: "Track prompts, responses, and costs" },
        { title: "Use Structured Output", desc: "JSON mode or function calling for reliability" },
      ].map((item, i) => (
        <div key={i} className="bg-card rounded-xl border border-border p-4">
          <h3 className="font-semibold text-foreground mb-1">{item.title}</h3>
          <p className="text-sm text-muted-foreground">{item.desc}</p>
        </div>
      ))}
    </div>
  </section>
);
